import React, {useState, useContext} from "react";
import {Button, Image} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import {PRODUCT_ROUTE} from "../utils/const";
import {Context} from "..";
import {CartDash, CartPlus} from "react-bootstrap-icons";
import RequestPriceModal from "./RequestPriceModal";
import ImageNotFound from '../assets/img/image_not_found.webp';
import FreeInstall from '../assets/img/free_install.png';
import DiscountInstall from '../assets/img/discount_install.png';
import {OverlayTrigger, Popover} from "react-bootstrap";
import {QuestionCircle} from "react-bootstrap-icons";
import { getDisplayStoreName } from '../utils/storeNameMap';



const ProductItem = ({productItem, modal, handleClose}) => {
    const navigate = useNavigate()
    const [count, setCount] = useState(0)
    const {user} = useContext(Context)
    const {product} = useContext(Context)
    const {postingNumber} = useParams()
    const [modalShow, setModalShow] = React.useState(false);

    const freeInstallAttr = productItem.attributes?.find(attr => attr.name === 'Бесплатный монтаж');
    const discountInstallAttr = productItem.attributes?.find(attr => attr.name === 'Скидка на монтаж, %');
        // Проверки
    const hasFreeInstall = freeInstallAttr?.value === '1'; // 1 - да, 2 - нет бесплатный монтаж
    const hasDiscountInstall = parseInt(discountInstallAttr?.value) > 0;
    const discountPercent = discountInstallAttr?.value;

    const isShowcaseSamplePossible = productItem.fullStock?.some(store => store.stock === 1);

    return (
        <div className="d-flex flex-column mb-4">
            <RequestPriceModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                productItem={productItem} // Передаем название товара
            />
            <div className="img_wrapper">
            {(hasFreeInstall || hasDiscountInstall) && (
                <div className="d-flex gap-2 mt-2">
                    {hasFreeInstall && (
                        <Image
                            src={FreeInstall}
                            alt="Монтаж в подарок"
                            width={80}
                            height="auto"
                            style={{objectFit: 'contain'}}
                        />
                    )}
                    {hasDiscountInstall && (
                        <div style={{position: 'relative', display: 'inline-block'}}>
                            <Image
                                src={DiscountInstall}
                                alt="Скидка на монтаж"
                                width={80}
                                height="auto"
                                style={{objectFit: 'contain'}}
                            />
                            <div style={{
                                position: 'absolute',
                                top: '30%',
                                left: 0,
                                width: '100%',
                                textAlign: 'center',
                                color: '#ff0000',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                textShadow: '1px 1px 3px #000'
                            }}>
                                -{discountPercent}%
                            </div>
                        </div>
            )}
                </div>
            )}
                <div className="img_frame d-flex align-items-center">
                    <a href={PRODUCT_ROUTE + '/' + productItem.id}>
                    <Image style={{cursor: 'pointer'}} className="rounded-4"
                           src={productItem.image ? process.env.REACT_APP_API_URL_PROD + "img/" + productItem.image : <Image height={300} src={ImageNotFound} />}
                        />
                    </a>
                </div>
            </div>

            {productItem.isSale && (
                <div className="badje text-light">-{productItem.discount}%</div>
            )}

{productItem.stock > 0 ? (
    <div className="priceline d-flex flex-column flex-md-row align-items-start">
        <div className="d-flex flex-wrap align-items-center">
            {productItem.isSale && (
                <>
                    <span className="basic_price text-danger me-2">{productItem.salePrice}₽</span>
                    <span className="text-secondary text-decoration-line-through me-2 firstprice">{productItem.price}₽</span>
                </>
            )}
            {!productItem.isSale && (
                <span className="basic_price me-2">{productItem.price}₽</span>
            )}
        </div>

        <div className="d-flex align-items-center ms-md-auto mt-2 mt-md-0">
            {product.getBasketCount(productItem) === 0 ? (
                <a
                    className="carticon text-light"
                    onClick={() => {
                        if (productItem.price > 0) {
                            product.addBasketProduct(productItem);
                            setCount(count + 1);
                        }
                    }}
                >
                    <CartPlus />
                </a>
            ) : (
                <>
                    <a
                        className="carticonminus text-light"
                        onClick={() => {
                            if (productItem.price > 0) {
                                setCount(product.getBasketCount(productItem) - 1);
                                product.changeCountBasketProduct(productItem, product.getBasketCount(productItem) - 1);
                            }
                        }}
                    >
                        <CartDash />
                    </a>
                    <div className="counter-catalog-product px-2">
                        {product.getBasketCount(productItem)}
                    </div>
                    <a
                        className="carticonplus text-light"
                        onClick={() => {
                            if (productItem.price > 0) {
                                setCount(product.getBasketCount(productItem) + 1);
                                product.changeCountBasketProduct(productItem, product.getBasketCount(productItem) + 1);
                            }
                        }}
                    >
                        <CartPlus />
                    </a>
                </>
            )}
        </div>
                </div>) : (
                <div className="priceline d-flex align-items-center">
                    <Button variant="dark" className="rounded-4" onClick={() => setModalShow(true)}>
                        Запросить цену
                    </Button>
                </div>
            )}
            <a className="flex-fill" href={PRODUCT_ROUTE + '/' + productItem.id}>
                <h2>{productItem.name}</h2>
            </a>
                {productItem.stock > 0 ? (
                    user.hasRoleShop ? (
                    <div className="text-secondary firstprice d-flex align-items-center">
                      <OverlayTrigger
                        trigger={['hover', 'focus', 'click']} // добавь click для мобилок!
                        placement="auto"
                        overlay={
                          <Popover id="popover-stock-info">
                            <Popover.Header as="h3">Доступно на складах</Popover.Header>
                            <Popover.Body>
                              {productItem.fullStock.map((store, idx) => (
                                <div key={idx}>
                                  <strong>{getDisplayStoreName(store.storeName)}</strong>: {store.stock} шт.
                                  {store.stock === 1 && <span>*</span>}
                                </div>
                              ))}
                              {isShowcaseSamplePossible && (
                                <div className="mt-2 text-muted" style={{ fontSize: '0.85rem' }}>
                                  * Может быть витринный образец
                                </div>
                              )}
                            </Popover.Body>
                          </Popover>
                        }
                      >
                        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                          Наличие — {productItem.fullStock.reduce((sum, s) => sum + s.stock, 0)} шт.
                          <QuestionCircle style={{ marginLeft: '5px' }} color="#6c757d" />
                        </div>
                      </OverlayTrigger>
                    </div>
                    ) : (
                        <span className="text-secondary firstprice">Наличие — {productItem.stock} шт.</span>
                    )
                ) : (
                    <span className="text-secondary firstprice text-danger">Нет в наличии</span>
                )}


        </div>
        );
};

export default ProductItem;